<template>
  <div>
    <div class="filter-bar mb-sm">
      <breadcrumb></breadcrumb>
      <div class="space"></div>
      <el-button size="small" type="primary" @click="onPre">预览</el-button>
      <el-button
        v-if="isSiyanSchool"
        size="small"
        type="primary"
        @click="showLessonDialog = true"
        >教研课</el-button
      >
      <el-button
        v-if="isSiyanSchool"
        size="small"
        type="primary"
        @click="showAssessmentDialog = true"
        >评估表</el-button
      >
      <el-button
        v-if="isSiyanSchool"
        size="small"
        type="primary"
        @click="showMeetingDialog = true"
        >会议记录</el-button
      >
      <el-button slot="reference" size="small" @click="$router.go(-1)"
        >返回</el-button
      >
    </div>
    <div v-loading="loading" class="content-box">
      <div>
        <span class="label">学年：</span>
        <span> {{ groupInfo?.schoolYear }}</span>
      </div>

      <div>
        <span class="label">相关文件：</span>
        <upload-link
          ref="linkBatchImport"
          accept="*"
          :fileLimit="10"
          @changeUpload="changeUpload"
          :showFileList="false"
          :file-list="[]"
        >
          <template slot="body">
            <el-button :loading="btnLoading" size="small" type="primary"
              >添加</el-button
            >
          </template>
        </upload-link>
      </div>
      <ul>
        <li class="clearfix" v-for="i in groupInfo?.attachList" :key="i.id">
          <i class="fl big-icon" :class="mapFileIcon(i.attachType)"></i>
          <div class="fl">
            <h1>
              {{
                i.attachName ||
                i.attachUrl.substring(
                  i.attachUrl.lastIndexOf("\/") + 1,
                  i.attachUrl.length
                )
              }}
            </h1>
            <h2>{{ i.attachSize }}kb</h2>
          </div>
          <el-divider class="fl divider" direction="vertical"></el-divider>
          <div class="fl">
            <h1>{{ i.createName }} {{ i.schoolName }}</h1>
            <h2>{{ i.createTime }}上传</h2>
          </div>
          <el-button
            type="text"
            class="dow fr"
            @click="downloadFile(i.attachUrl, i.attachName)"
            >下载</el-button
          >
          <el-button
            v-if="i.id"
            type="text"
            class="del fr"
            @click="delAttach(i.id)"
            >移除</el-button
          >
          <el-button type="text" class="look fr" @click="lookFile(i.attachUrl)"
            >查看</el-button
          >
        </li>
      </ul>

      <div>
        <h2 class="label">教研组长：</h2>
        <span> {{ groupInfo?.leaderName }}</span>
      </div>
      <div style="flex-direction: column">
        <h2 class="label">成员列表：</h2>
        <el-table :data="tableData" style="width: 100%">
          <el-table-column
            align="center"
            prop="userName"
            label="姓名"
            width="80"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="userSex"
            label="性别"
            width="50"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="birthday"
            label="出生年月"
            width="120"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="userDutyDesc"
            label="职称（务）"
            width="120"
          >
            <template slot-scope="scope">
              {{ scope.row.teacherArchivesDTO?.academicTitlesDesc }}</template
            >
          </el-table-column>
          <el-table-column
            align="center"
            prop="userDutyDesc"
            label="学历"
            width="120"
          >
            <template slot-scope="scope">
              {{ scope.row.teacherArchivesDTO?.educationDesc }}
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="teachingAge"
            label="教龄"
            width="50"
          >
            <template slot-scope="scope">
              {{ scope.row.teacherArchivesDTO?.teachingAge }}
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="className"
            label="任课年级（班）"
          >
            <template slot-scope="scope">
              {{ scope.row.teacherArchivesDTO?.className }}</template
            >
          </el-table-column>
          <el-table-column align="center" label="任课节数">
            <template slot-scope="scope">
              {{
                scope.row.teacherArchivesDTO?.remark &&
                JSON.parse(scope.row.teacherArchivesDTO.remark)?.teachNum
              }}</template
            >
          </el-table-column>
          <el-table-column align="center" prop="userDutyDesc" label="进修情况">
            <template slot-scope="scope">
              {{
                scope.row.teacherArchivesDTO?.remark &&
                JSON.parse(scope.row.teacherArchivesDTO.remark)?.furtherEdu
              }}</template
            >
          </el-table-column>
          <el-table-column align="center" prop="userDutyDesc" label="社会工作">
            <template slot-scope="scope">
              {{
                scope.row.teacherArchivesDTO?.remark &&
                JSON.parse(scope.row.teacherArchivesDTO.remark)?.socialWork
              }}</template
            >
          </el-table-column>
          <el-table-column align="center" prop="remark" label="备注">
            <template slot-scope="scope">
              {{
                scope.row.teacherArchivesDTO?.remark &&
                JSON.parse(scope.row.teacherArchivesDTO.remark)
                  ?.researchGroupRemark
              }}</template
            >
          </el-table-column>
        </el-table>
      </div>
      <!-- <div style="flex-direction: column">
        <h2 class="label">活动统计：</h2>
        <el-row style="margin: 10px 0">
          <el-col :span="4">
            教研组研究专题：{{ actStatistics?.topicCount }}次
          </el-col>
          <el-col :span="4">
            课外活动：{{ actStatistics?.afterClassCount }}次
          </el-col>
          <el-col :span="4">
            教研组活动：{{ actStatistics?.researchCount }}次
          </el-col>
          <el-col :span="4">
            新教师带教：{{ actStatistics?.teachCount }}组
          </el-col>
          <el-col :span="4">
            备课组活动： {{ actStatistics?.prepareClassCount }}次
          </el-col>
        </el-row>
      </div> -->
      <!-- <div style="flex-direction: column">
        <h2 class="label">工作完成情况统计：</h2>
        <el-table :data="tableTeacherStatistics" style="width: 100%">
          <el-table-column
            prop="teacherName"
            label="姓名"
            align="center"
            width="80"
          >
          </el-table-column>
          <el-table-column
            prop="hostClassNum"
            label="公开课节数"
            align="center"
            width="120"
          >
          </el-table-column>
          <el-table-column
            prop="joinClassNum"
            label="听课节数"
            align="center"
            width="120"
          >
          </el-table-column>
          <el-table-column
            prop="joinResearchNum"
            label="参加教研活动次数"
            align="center"
            width="80"
          >
          </el-table-column>
          <el-table-column
            prop="unSignResearchNum"
            label="补缺次数"
            align="center"
            width="120"
          >
          </el-table-column>
          <el-table-column
            prop="afterClassNum"
            label="课外活动辅导次数"
            align="center"
            width="80"
          >
          </el-table-column>
          <el-table-column
            prop="afterClassNum"
            label="指导学生获奖人数等第"
            align="center"
            width="90"
          >
          </el-table-column>
          <el-table-column
            prop="articlesNum"
            label="文章经验等发表交流范围及篇数"
            align="center"
            width="120"
          >
          </el-table-column>
          <el-table-column
            prop="awardsNum"
            label="获奖情况"
            align="center"
            width="120"
          >
          </el-table-column>
          <el-table-column prop="remark" label="备注" align="center">
          </el-table-column>
        </el-table>
      </div> -->
      <div style="flex-direction: column; justify-content: center">
        <div style="width: 600px">
          <h2 class="label fl">工作计划：</h2>
          <el-button
            v-if="form.planStatus"
            size="small"
            type="link"
            class="fr"
            @click="form.planStatus = false"
            >编辑</el-button
          >
          <el-button
            size="small"
            type="link"
            class="fr"
            v-if="!form.planStatus"
            @click="updateGroupPlanSummary('plan')"
            >保存</el-button
          >
        </div>
        <el-input
          :readonly="form.planStatus"
          type="textarea"
          :autosize="{ minRows: 5, maxRows: 8 }"
          maxlength="500"
          show-word-limit
          style="width: 600px"
          v-model="groupInfo.plan"
        ></el-input>
      </div>
      <div style="flex-direction: column; justify-content: center">
        <div style="width: 600px">
          <h2 class="label fl">工作总结：</h2>
          <el-button
            v-if="form.summaryStatus"
            size="small"
            type="link"
            class="fr"
            @click="form.summaryStatus = false"
            >编辑</el-button
          >
          <el-button
            size="small"
            type="link"
            class="fr"
            v-if="!form.summaryStatus"
            @click="updateGroupPlanSummary('summary')"
            >保存</el-button
          >
        </div>
        <el-input
          :readonly="form.summaryStatus"
          type="textarea"
          :autosize="{ minRows: 5, maxRows: 8 }"
          maxlength="500"
          show-word-limit
          style="width: 600px"
          v-model="groupInfo.summary"
        ></el-input>
      </div>
      <div style="flex-direction: column; justify-content: center">
        <div style="width: 600px">
          <h2 class="label fl">专题研究总结：</h2>
          <el-button
            v-if="form.researchSummaryStatus"
            size="small"
            type="link"
            class="fr"
            @click="form.researchSummaryStatus = false"
            >编辑</el-button
          >
          <el-button
            size="small"
            type="link"
            class="fr"
            v-if="!form.researchSummaryStatus"
            @click="updateGroupPlanSummary('researchSummary')"
            >保存</el-button
          >
        </div>
        <el-input
          :readonly="form.researchSummaryStatus"
          type="textarea"
          :autosize="{ minRows: 5, maxRows: 8 }"
          maxlength="500"
          show-word-limit
          style="width: 600px"
          v-model="groupInfo.researchSummary"
        >        </el-input>
      </div>
    </div>

    <!-- 教研课弹窗 -->
    <el-dialog
      title="教研课"
      :visible.sync="showLessonDialog"
      width="900px"
      @closed="handleLessonDialogClose"
    >
      <div style="margin-bottom: 10px; text-align: right">
        <el-button type="primary" size="small" @click="handleAddLesson"
          >新增</el-button
        >
      </div>
      <el-table
        :data="lessonList"
        v-loading="lessonLoading"
        style="width: 100%"
        border
      >
        <el-table-column prop="lessonTea" label="执教者" width="120">
        </el-table-column>
        <el-table-column prop="content" label="内容" min-width="200">
        </el-table-column>
        <el-table-column prop="lessonTime" label="时间" width="180">
        </el-table-column>
        <el-table-column prop="lessonAddress" label="地点" width="150">
        </el-table-column>
        <el-table-column prop="level" label="级别" width="120">
        </el-table-column>
        <el-table-column label="操作" width="150" fixed="right">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="handleEditLesson(scope.row)"
              >编辑</el-button
            >
            <el-button
              type="text"
              size="small"
              style="color: #f56c6c"
              @click="handleDeleteLesson(scope.row.id)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <!-- 教研课新增/编辑弹窗 -->
    <el-dialog
      :title="lessonForm.id ? '编辑教研课' : '新增教研课'"
      :visible.sync="showLessonFormDialog"
      width="600px"
      @closed="handleLessonFormDialogClose"
    >
      <el-form
        :model="lessonForm"
        :rules="lessonRules"
        ref="lessonForm"
        label-width="100px"
      >
        <el-form-item label="执教者" prop="lessonTea">
          <el-input v-model="lessonForm.lessonTea" placeholder="请输入执教者"></el-input>
        </el-form-item>
        <el-form-item label="内容" prop="content">
          <el-input
            type="textarea"
            :rows="4"
            v-model="lessonForm.content"
            placeholder="请输入内容"
          ></el-input>
        </el-form-item>
        <el-form-item label="时间" prop="lessonTime">
          <el-input v-model="lessonForm.lessonTime" placeholder="请输入时间"></el-input>
        </el-form-item>
        <el-form-item label="地点" prop="lessonAddress">
          <el-input
            v-model="lessonForm.lessonAddress"
            placeholder="请输入地点"
          ></el-input>
        </el-form-item>
        <el-form-item label="级别" prop="level">
          <el-input v-model="lessonForm.level" placeholder="请输入级别"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showLessonFormDialog = false">取消</el-button>
        <el-button type="primary" @click="handleSaveLesson" :loading="lessonSaving"
          >保存</el-button
        >
      </div>
    </el-dialog>

    <!-- 会议记录弹窗 -->
    <el-dialog
      title="会议记录"
      :visible.sync="showMeetingDialog"
      width="900px"
      @closed="handleMeetingDialogClose"
    >
      <div style="margin-bottom: 10px; text-align: right">
        <el-button type="primary" size="small" @click="handleAddMeeting"
          >新增</el-button
        >
      </div>
      <el-table
        :data="meetingList"
        v-loading="meetingLoading"
        style="width: 100%"
        border
      >
        <el-table-column prop="meetTime" label="会议时间" width="180">
        </el-table-column>
        <el-table-column prop="meetAddress" label="会议地点" width="150">
        </el-table-column>
        <el-table-column prop="meetContent" label="会议过程" min-width="300">
        </el-table-column>
        <el-table-column label="操作" width="150" fixed="right">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="handleEditMeeting(scope.row)"
              >编辑</el-button
            >
            <el-button
              type="text"
              size="small"
              style="color: #f56c6c"
              @click="handleDeleteMeeting(scope.row.id)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <!-- 会议记录新增/编辑弹窗 -->
    <el-dialog
      :title="meetingForm.id ? '编辑会议记录' : '新增会议记录'"
      :visible.sync="showMeetingFormDialog"
      width="600px"
      @closed="handleMeetingFormDialogClose"
    >
      <el-form
        :model="meetingForm"
        :rules="meetingRules"
        ref="meetingForm"
        label-width="100px"
      >
        <el-form-item label="会议时间" prop="meetTime">
          <el-input v-model="meetingForm.meetTime" placeholder="请输入会议时间"></el-input>
        </el-form-item>
        <el-form-item label="会议地点" prop="meetAddress">
          <el-input
            v-model="meetingForm.meetAddress"
            placeholder="请输入会议地点"
          ></el-input>
        </el-form-item>
        <el-form-item label="会议过程" prop="meetContent">
          <el-input
            type="textarea"
            :rows="6"
            v-model="meetingForm.meetContent"
            placeholder="请输入会议过程"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showMeetingFormDialog = false">取消</el-button>
        <el-button type="primary" @click="handleSaveMeeting" :loading="meetingSaving"
          >保存</el-button
        >
      </div>
    </el-dialog>

    <!-- 评估表弹窗 -->
    <el-dialog
      title="评估表"
      :visible.sync="showAssessmentDialog"
      width="1200px"
      @closed="handleAssessmentDialogClose"
    >
      <div style="margin-bottom: 10px; text-align: right">
        <el-button
          type="danger"
          size="small"
          v-if="assessmentForm.id"
          @click="handleDeleteAssessment"
          >删除</el-button
        >
        <el-button type="primary" size="small" @click="handleSaveAssessment" :loading="assessmentSaving"
          >保存</el-button
        >
      </div>
      <el-table
        :data="assessmentTableData"
        v-loading="assessmentLoading"
        style="width: 100%"
        border
        :span-method="objectSpanMethod"
      >
        <el-table-column prop="index" label="序号" width="60" align="center">
        </el-table-column>
        <el-table-column prop="primaryIndicator" label="一级指标" width="150" align="center">
        </el-table-column>
        <el-table-column prop="secondaryIndicator" label="二级指标" min-width="300">
        </el-table-column>
        <el-table-column prop="scoreValue" label="分值" width="80" align="center">
        </el-table-column>
        <el-table-column label="自评" width="120" align="center">
          <template slot-scope="scope">
            <el-input-number
              v-model="scope.row.selfScore"
              :min="0"
              :max="scope.row.scoreValue"
              :precision="1"
              size="small"
              style="width: 100%"
              :disabled="!scope.row.scoreValue"
            ></el-input-number>
          </template>
        </el-table-column>
        <el-table-column label="校评" width="120" align="center">
          <template slot-scope="scope">
            <el-input-number
              v-model="scope.row.schoolScore"
              :min="0"
              :max="scope.row.scoreValue"
              :precision="1"
              size="small"
              style="width: 100%"
              :disabled="!scope.row.scoreValue"
            ></el-input-number>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 20px; text-align: right; font-weight: bold">
        <span>总分：自评 {{ totalSelfScore }} / 校评 {{ totalSchoolScore }}</span>
      </div>
    </el-dialog>

    <!-- 删除确认弹窗 -->
    <popup-del :delVisible="delVisible" @close="closePopupDel"></popup-del>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { postData, postJson, getData } from "../../../http/fetch";
import UploadLink from "@/components/upload/UploadLink.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";
import PopupDel from "@/components/PopupDel.vue";

import {
  mapFileIcon,
  mapLinkIcon,
  lookFile,
  downloadUrlFile,
  power,
} from "@/utils/index.js";
export default {
  components: {
    UploadLink,
    Breadcrumb,
    PopupDel,
  },
  data() {
    return {
      groupCode: "",
      groupInfo: {
        plan: "",
        summary: "",
        researchSummary: "",
      },
      loading: false,
      btnLoading: false,
      tableData: [],
      tableTeacherStatistics: [],
      actStatistics: null,
      form: {
        planStatus: true,
        summaryStatus: true,
        researchSummaryStatus: true,
      },
      // 教研课相关
      showLessonDialog: false,
    showAssessmentDialog: false,
      showLessonFormDialog: false,
      lessonList: [],
      lessonLoading: false,
      lessonSaving: false,
      lessonForm: {
        id: null,
        schoolCode: '',
        groupCode: '',
        lessonTea: '',
        content: '',
        lessonTime: '',
        lessonAddress: '',
        level: '',
        operatorId: '',
      },
      lessonRules: {
        lessonTea: [{ required: true, message: '请输入执教者', trigger: 'blur' }],
        content: [{ required: true, message: '请输入内容', trigger: 'blur' }],
        lessonTime: [{ required: true, message: '请输入时间', trigger: 'blur' }],
        lessonAddress: [{ required: true, message: '请输入地点', trigger: 'blur' }],
        level: [{ required: true, message: '请输入级别', trigger: 'blur' }],
      },
      // 会议记录相关
      showMeetingDialog: false,
      showMeetingFormDialog: false,
      meetingList: [],
      meetingLoading: false,
      meetingSaving: false,
      meetingForm: {
        id: null,
        meetTime: '',
        meetAddress: '',
        meetContent: '',
        groupCode: '',
        schoolCode: '',
      },
      meetingRules: {
        meetTime: [{ required: true, message: '请输入会议时间', trigger: 'blur' }],
        meetAddress: [{ required: true, message: '请输入会议地点', trigger: 'blur' }],
        meetContent: [{ required: true, message: '请输入会议过程', trigger: 'blur' }],
      },
      // 删除相关
      delVisible: false,
      deleteId: null,
      deleteType: '', // 'lesson' 或 'meeting'
      // 评估表相关
      assessmentLoading: false,
      assessmentSaving: false,
      assessmentForm: {
        id: null,
        groupCode: '',
        schoolCode: '',
        selfScore: '',
        schoolScore: '',
      },
      // 评估表固定数据结构
      assessmentTableData: [],
    };
  },
  mounted() {
    if (sessionStorage.getItem("groupCode")) {
      this.groupCode = sessionStorage.getItem("groupCode");
      this.getDeatail(this.groupCode);
      this.getResearchGroupTeacherList(this.groupCode);
      // this.getGroupTeacherStatistics(this.groupCode);
      // this.getGroupActStatistics(this.groupCode);
    }
  },
  computed: {
    ...mapState(["userInfo", "isAdmin"]),
    // 判断是否是思言小学
    isSiyanSchool() {
      return this.userInfo?.schoolCode === 'fxqsyxx'
    },
    // 计算自评总分
    totalSelfScore() {
      return this.assessmentTableData.reduce((sum, item) => {
        return sum + (parseFloat(item.selfScore) || 0);
      }, 0).toFixed(1);
    },
    // 计算校评总分
    totalSchoolScore() {
      return this.assessmentTableData.reduce((sum, item) => {
        return sum + (parseFloat(item.schoolScore) || 0);
      }, 0).toFixed(1);
    },
  },
  methods: {
    mapFileIcon,
    mapLinkIcon,
    lookFile,
    power,
    onPre() {
      // 如果 schoolCode 为 fxqsyxx，跳转到新的预览页面
      const routeName = this.userInfo?.schoolCode === 'fxqsyxx' 
        ? 'previewHandbookSiyan' 
        : 'previewHandbook';
      this.$router.push({
        name: routeName,
        query: {
          groupCode: this.groupCode,
        },
      });
    },
    async updateGroupPlanSummary(type) {
      if (!this.groupInfo[type]) {
        this.$message.warning("请填写相关内容");
        return;
      } else {
        await postJson("/researchGroup/updateGroupPlanSummary", {
          groupCode: this.groupCode,
          id: this.groupInfo.id,
          operatorId: this.userInfo.userId,
          [type]: this.groupInfo[type],
        });
        this.form.planStatus = true;
        this.form.summaryStatus = true;
        this.form.researchSummaryStatus = true;
        this.$message.success("保存成功");
        this.getDeatail(this.groupCode);
      }
    },
    async getDeatail(groupCode) {
      
      this.loading = true;
      await postData("/researchGroup/getResearchGroupInfo", {
        schoolCode: this.userInfo.orgCode || this.userInfo.schoolCode,
        groupCode,
      })
        .then((res) => {
          this.groupInfo = res;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async delAttach(id) {
      await postJson("/researchGroup/deleteResearchGroupAttach", {
        operatorId: this.userInfo.userId,
        id,
      });
      this.getDeatail(this.groupCode);
    },
    async getResearchGroupTeacherList(groupCode) {
      this.loading = true;
      await postData("/researchGroup/getResearchGroupTeacherList", {
        schoolCode: this.userInfo.schoolCode,
        groupCode,
      })
        .then((res) => {
          this.tableData = res;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async getGroupActStatistics(groupCode) {
      this.loading = true;
      await postData("/researchGroup/getGroupActStatistics", {
        groupCode,
      })
        .then((res) => {
          this.actStatistics = res;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async getGroupTeacherStatistics(groupCode) {
      this.loading = true;
      await postData("/researchGroup/getGroupTeacherStatistics", {
        groupCode,
      })
        .then((res) => {
          this.tableTeacherStatistics = res;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    downloadFile(url, name) {
      //确认下载完成 后 进行下载记录保存
      downloadUrlFile(url, name);
      //保存下载记录
      // postJson("/operator/saveDownloadInfo", {
      // 	infoCode: sessionStorage.getItem("actCode"),
      // 	module: "research",
      // 	operatorId: this.userInfo.userId,
      // 	schoolCode: this.userInfo.schoolCode
      // });
    },
    async changeUpload(fileList) {
      this.btnLoading = true;
      await postJson("/researchGroup/saveResearchGroupAttach", {
        ...fileList[fileList.length - 1],
        groupCode: this.groupCode,
        operatorId: this.userInfo.userId,
      });
      await this.getDeatail(this.groupCode);
      this.btnLoading = false;
    },
    // 教研课相关方法
    async getLessonList() {
      this.lessonLoading = true;
      try {
        const data = await getData('/sy-group-table/list', {
          schoolCode: this.userInfo.schoolCode,
          groupCode: this.groupCode,
        });
        this.lessonList = data || [];
      } catch (err) {
        console.log('获取教研课列表失败', err);
      } finally {
        this.lessonLoading = false;
      }
    },
    handleAddLesson() {
      this.lessonForm = {
        id: null,
        schoolCode: this.userInfo.schoolCode,
        groupCode: this.groupCode,
        lessonTea: '',
        content: '',
        lessonTime: '',
        lessonAddress: '',
        level: '',
        operatorId: this.userInfo.userId,
      };
      this.showLessonFormDialog = true;
    },
    handleEditLesson(row) {
      this.lessonForm = {
        id: row.id,
        schoolCode: row.schoolCode || this.userInfo.schoolCode,
        groupCode: row.groupCode || this.groupCode,
        lessonTea: row.lessonTea || '',
        content: row.content || '',
        lessonTime: row.lessonTime || '',
        lessonAddress: row.lessonAddress || '',
        level: row.level || '',
        operatorId: this.userInfo.userId,
      };
      this.showLessonFormDialog = true;
    },
    async handleSaveLesson() {
      this.$refs.lessonForm.validate(async (valid) => {
        if (valid) {
          this.lessonSaving = true;
          try {
            await postJson('/sy-group-table/save', this.lessonForm);
            this.$message.success('保存成功');
            this.showLessonFormDialog = false;
            this.getLessonList();
          } catch (err) {
            console.log('保存失败', err);
          } finally {
            this.lessonSaving = false;
          }
        }
      });
    },
    handleDeleteLesson(id) {
      this.deleteId = id;
      this.deleteType = 'lesson';
      this.delVisible = true;
    },
    handleLessonDialogClose() {
      this.lessonList = [];
    },
    handleLessonFormDialogClose() {
      this.$refs.lessonForm && this.$refs.lessonForm.resetFields();
      this.lessonForm = {
        id: null,
        schoolCode: '',
        groupCode: '',
        lessonTea: '',
        content: '',
        lessonTime: '',
        lessonAddress: '',
        level: '',
        operatorId: '',
      };
    },
    // 会议记录相关方法
    async getMeetingList() {
      this.meetingLoading = true;
      try {
        const data = await getData('/sy-group-table/list-meet', {
          schoolCode: this.userInfo.schoolCode,
          groupCode: this.groupCode,
        });
        this.meetingList = data || [];
      } catch (err) {
        console.log('获取会议记录列表失败', err);
      } finally {
        this.meetingLoading = false;
      }
    },
    handleAddMeeting() {
      this.meetingForm = {
        id: null,
        meetTime: '',
        meetAddress: '',
        meetContent: '',
        groupCode: this.groupCode,
        schoolCode: this.userInfo.schoolCode,
      };
      this.showMeetingFormDialog = true;
    },
    handleEditMeeting(row) {
      this.meetingForm = {
        id: row.id,
        meetTime: row.meetTime || '',
        meetAddress: row.meetAddress || '',
        meetContent: row.meetContent || '',
        groupCode: row.groupCode || this.groupCode,
        schoolCode: row.schoolCode || this.userInfo.schoolCode,
      };
      this.showMeetingFormDialog = true;
    },
    async handleSaveMeeting() {
      this.$refs.meetingForm.validate(async (valid) => {
        if (valid) {
          this.meetingSaving = true;
          try {
            await postJson('/sy-group-table/save-meet', this.meetingForm);
            this.$message.success('保存成功');
            this.showMeetingFormDialog = false;
            this.getMeetingList();
          } catch (err) {
            console.log('保存失败', err);
          } finally {
            this.meetingSaving = false;
          }
        }
      });
    },
    handleDeleteMeeting(id) {
      this.deleteId = id;
      this.deleteType = 'meeting';
      this.delVisible = true;
    },
    handleMeetingDialogClose() {
      this.meetingList = [];
    },
    handleMeetingFormDialogClose() {
      this.$refs.meetingForm && this.$refs.meetingForm.resetFields();
      this.meetingForm = {
        id: null,
        meetTime: '',
        meetAddress: '',
        meetContent: '',
        groupCode: '',
        schoolCode: '',
      };
    },
    // 删除确认
    async closePopupDel(status) {
      if (status) {
        try {
          if (this.deleteType === 'lesson') {
            await getData('/sy-group-table/delete', { id: this.deleteId });
            this.$message.success('删除成功');
            this.getLessonList();
          } else if (this.deleteType === 'meeting') {
            await getData('/sy-group-table/delete-meet', { id: this.deleteId });
            this.$message.success('删除成功');
            this.getMeetingList();
          } else if (this.deleteType === 'assessment') {
            await getData('/sy-group-table/delete-table', { id: this.deleteId });
            this.$message.success('删除成功');
            this.initAssessmentTable();
            this.assessmentForm = {
              id: null,
              groupCode: this.groupCode,
              schoolCode: this.userInfo.schoolCode,
              selfScore: '',
              schoolScore: '',
            };
          }
        } catch (err) {
          console.log('删除失败', err);
        }
      }
      this.delVisible = false;
      this.deleteId = null;
      this.deleteType = '';
    },
    // 评估表相关方法
    // 初始化评估表数据结构
    initAssessmentTable() {
      this.assessmentTableData = [
        // 1. 学习制度 (总分4)
        { index: 1, primaryIndicator: '学习制度', secondaryIndicator: '定期组织学习教育理论、文件和教学业务知识（每学期不少于三次，且有记录）', scoreValue: 2, selfScore: null, schoolScore: null },
        { index: 2, primaryIndicator: '', secondaryIndicator: '认真按照课程标准要求进行教学,教学进度合理。期初有计划,期末有总结,并定期向学校领导和组室教师汇报工作', scoreValue: 2, selfScore: null, schoolScore: null },
        // 2. 课程建设 (总分8)
        { index: 3, primaryIndicator: '课程建设', secondaryIndicator: '按课程标准要求开设课程,基础型、拓展型、探究型(研究型)课程安排理。', scoreValue: 4, selfScore: null, schoolScore: null },
        { index: 4, primaryIndicator: '', secondaryIndicator: '积极开设学科拓展型、探究型(研究型)课程,做到计划、内容、人员、时间、场所等五落实', scoreValue: 4, selfScore: null, schoolScore: null },
        // 3. 教师研修 (总分19)
        { index: 5, primaryIndicator: '教师研修', secondaryIndicator: '认真参加市、区、片各级教研活动,并及时传达有关精神。教研活动出席率高,并在活动中发挥骨干作用', scoreValue: 5, selfScore: null, schoolScore: null },
        { index: 6, primaryIndicator: '', secondaryIndicator: '注重新教师、骨干教师等培养,有教师专业素养提高的规划和措施', scoreValue: 3, selfScore: null, schoolScore: null },
        { index: 7, primaryIndicator: '', secondaryIndicator: '教师区、市级教学评比中获奖情况,承担区级及以上命题、研究课、公开课的示范、辐射作用', scoreValue: 6, selfScore: null, schoolScore: null },
        { index: 8, primaryIndicator: '', secondaryIndicator: '教师相互听课、评课的记录情况(每人每学期不少于10节,教研组长每学期不少于20节)', scoreValue: 5, selfScore: null, schoolScore: null },
        // 4. 教学计划 (总分7)
        { index: 9, primaryIndicator: '教学计划', secondaryIndicator: '有健全的集体备课制度(定时间、定要求,做到教学进度、教学要求、考查要求统一)', scoreValue: 5, selfScore: null, schoolScore: null },
        { index: 10, primaryIndicator: '', secondaryIndicator: '组室、教导处有检查措施,落实到位,并有评价。', scoreValue: 2, selfScore: null, schoolScore: null },
        // 5. 课堂教学 (总分36)
        { index: 11, primaryIndicator: '课堂教学', secondaryIndicator: '教师的教学设计、二度修改、课后反思、教学资料积累', scoreValue: 5, selfScore: null, schoolScore: null },
        { index: 12, primaryIndicator: '', secondaryIndicator: '教学目标落实,重点突出,教学手段运用恰当。', scoreValue: 5, selfScore: null, schoolScore: null },
        { index: 13, primaryIndicator: '', secondaryIndicator: '教师专业素养扎实,教学能力强,能体现教学民主', scoreValue: 5, selfScore: null, schoolScore: null },
        { index: 14, primaryIndicator: '', secondaryIndicator: '教学活动组织有序,教学反馈及时,教学效果好。', scoreValue: 5, selfScore: null, schoolScore: null },
        { index: 15, primaryIndicator: '', secondaryIndicator: '严格按照文件精神安排作业量,有明确的作业规范要求(格式、书写等);作业形式多样化。', scoreValue: 4, selfScore: null, schoolScore: null },
        { index: 16, primaryIndicator: '', secondaryIndicator: '认真、及时批改作业,努力提高作业的效益。', scoreValue: 4, selfScore: null, schoolScore: null },
        { index: 17, primaryIndicator: '', secondaryIndicator: '组室、教导处有作业量、作业批改情况的检查措施,落实到位。', scoreValue: 2, selfScore: null, schoolScore: null },
        { index: 18, primaryIndicator: '', secondaryIndicator: '对学有困难的学生,能够有针对性地开展辅导', scoreValue: 3, selfScore: null, schoolScore: null },
        { index: 19, primaryIndicator: '', secondaryIndicator: '对学有余力的学生,能够有针对性地开展辅导,在区、市学科竞赛中获奖情况。', scoreValue: 3, selfScore: null, schoolScore: null },
        // 6. 质量管理 (总分16)
        { index: 20, primaryIndicator: '质量管理', secondaryIndicator: '升学考、区调研测试等教学成绩在同年级中的情况。', scoreValue: 10, selfScore: null, schoolScore: null },
        { index: 21, primaryIndicator: '', secondaryIndicator: '定期分析学生学习质量,并采取相应改进措施。研究考试命题、质量分析等质量监控工作情况。', scoreValue: 3, selfScore: null, schoolScore: null },
        { index: 22, primaryIndicator: '', secondaryIndicator: '重视学生实际学习能力的考查,注重以学生为本的观点来评估教学质量。', scoreValue: 3, selfScore: null, schoolScore: null },

        // 7. 教育科研 (总分6)
        { index: 23, primaryIndicator: '教育科研', secondaryIndicator: '教研组教学研究专题、进行教育科研课题研究工作情况。', scoreValue: 3, selfScore: null, schoolScore: null },
        { index: 24, primaryIndicator: '', secondaryIndicator: '教师在区、市级刊物上发表学术文章(或作品)情况。', scoreValue: 3, selfScore: null, schoolScore: null },
        // 8. 资料积累 (总分4)
        { index: 23, primaryIndicator: '资料积累', secondaryIndicator: '重视积累和合理使用各种教学资料,自制教具和改进教学手段器,对实验室、语音室,及其他专用教室的管理、使用情况。', scoreValue: 2, selfScore: null, schoolScore: null },
        { index: 24, primaryIndicator: '', secondaryIndicator: '教研组工作手册等资料的记录、保管情况。', scoreValue: 2, selfScore: null, schoolScore: null },
      ];
    },
    // 表格合并单元格
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      // 只合并一级指标列（columnIndex === 1）
      if (columnIndex === 1) {
        if (row.primaryIndicator) {
          // 计算当前一级指标有多少行
          let rowspan = 1;
          for (let i = rowIndex + 1; i < this.assessmentTableData.length; i++) {
            if (this.assessmentTableData[i].primaryIndicator === '') {
              rowspan++;
            } else {
              break;
            }
          }
          return {
            rowspan: rowspan,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    // 获取评估表数据
    async getAssessmentData() {
      this.assessmentLoading = true;
      try {
        const data = await getData('/sy-group-table/list-table', {
          schoolCode: this.userInfo.schoolCode,
          groupCode: this.groupCode,
        });
        if (data && data.length > 0) {
          const assessment = data[0];
          this.assessmentForm = {
            id: assessment.id,
            groupCode: assessment.groupCode || this.groupCode,
            schoolCode: assessment.schoolCode || this.userInfo.schoolCode,
            selfScore: assessment.selfScore || '',
            schoolScore: assessment.schoolScore || '',
          };
          // 将保存的分数填充到表格中
          if (assessment.selfScore) {
            const selfScores = assessment.selfScore.split(',');
            selfScores.forEach((score, index) => {
              if (this.assessmentTableData[index]) {
                this.$set(this.assessmentTableData[index], 'selfScore', parseFloat(score) || null);
              }
            });
          }
          if (assessment.schoolScore) {
            const schoolScores = assessment.schoolScore.split(',');
            schoolScores.forEach((score, index) => {
              if (this.assessmentTableData[index]) {
                this.$set(this.assessmentTableData[index], 'schoolScore', parseFloat(score) || null);
              }
            });
          }
        } else {
          // 没有数据，重置表单
          this.assessmentForm = {
            id: null,
            groupCode: this.groupCode,
            schoolCode: this.userInfo.schoolCode,
            selfScore: '',
            schoolScore: '',
          };
        }
      } catch (err) {
        console.log('获取评估表数据失败', err);
      } finally {
        this.assessmentLoading = false;
      }
    },
    // 保存评估表
    async handleSaveAssessment() {
      // 收集所有自评和校评分数，用逗号分隔
      const selfScores = this.assessmentTableData.map(item => (item.selfScore || 0)).join(',');
      const schoolScores = this.assessmentTableData.map(item => (item.schoolScore || 0)).join(',');
      
      this.assessmentSaving = true;
      try {
        const params = {
          id: this.assessmentForm.id,
          groupCode: this.groupCode,
          schoolCode: this.userInfo.schoolCode,
          selfScore: selfScores,
          schoolScore: schoolScores,
        };
        await postJson('/sy-group-table/save-table', params);
        this.$message.success('保存成功');
        this.getAssessmentData();
      } catch (err) {
        console.log('保存失败', err);
      } finally {
        this.assessmentSaving = false;
      }
    },
    // 删除评估表
    handleDeleteAssessment() {
      if (!this.assessmentForm.id) {
        return;
      }
      this.deleteId = this.assessmentForm.id;
      this.deleteType = 'assessment';
      this.delVisible = true;
    },
    // 评估表弹窗关闭
    handleAssessmentDialogClose() {
      this.assessmentTableData = [];
      this.assessmentForm = {
        id: null,
        groupCode: '',
        schoolCode: '',
        selfScore: '',
        schoolScore: '',
      };
    },
  },
  watch: {
    showLessonDialog(val) {
      if (val) {
        this.getLessonList();
      }
    },
    showMeetingDialog(val) {
      if (val) {
        this.getMeetingList();
      }
    },
    showAssessmentDialog(val) {
      if (val) {
        this.initAssessmentTable();
        this.getAssessmentData();
      }
    },
  },
};
</script>
<style lang="less" scoped>
.content-box {
  background-color: #fff;
  padding: 20px;
  > div {
    font-size: 16px;
    margin: 20px 0;
    display: flex;
    .label {
      min-width: 100px;
      font-size: 14px;
      font-weight: 600;
      color: #000000;
    }
  }
  ul {
    padding-left: 8px;
    // border: 1px solid rgb(241, 237, 237);
    // max-height: 357px;
    min-height: 40px;
    // overflow-y: auto;
    li {
      padding: 8px;
      margin-bottom: 15px;
      border: 1px solid rgb(224, 222, 222);
      border-radius: 5px;
      .big-icon {
        font-size: 35px;
        color: @color;
        // font-weight: 700;
      }
      .divider {
        margin-left: 20px;
        // border: 0.3px solid rgb(226, 220, 220);
        height: 38px;
      }
      h1 {
        font-size: 13px;
        padding-left: 10px;
      }

      h2 {
        margin-top: 2px;
        font-size: 12px;
        padding-left: 10px;
        color: @hui;
      }
      .look {
        margin-right: 60px;
      }
      .dow {
        margin-right: 100px;
      }
      .del {
        margin-right: 60px;
      }
    }
  }
}
</style>
